var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "seo-content-accordion" }, [
    _c("div", { staticClass: "seo-content-accordion__wrapper" }, [
      _c("h2", { staticClass: "seo-content-accordion__header" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c(
        "div",
        {
          staticClass: "seo-content-accordion__content",
          style: _vm.contentBlockHeight
        },
        [
          _c("div", {
            ref: "content",
            domProps: { innerHTML: _vm._s(_vm.content) }
          })
        ]
      ),
      _c("div", { staticClass: "seo-content-accordion__cta-wrapper" }, [
        _c(
          "button",
          {
            staticClass: "link link--secondary",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.activate($event)
              }
            }
          },
          [
            _c("span", { staticClass: "link__content" }, [
              _vm._v(_vm._s(_vm.active ? "Read Less" : "Read More"))
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }